import React, { useState, useEffect } from "react";
import { Application } from "./Application";
import { Account } from "./Account";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import "./index.css";

import { StartYourProject } from "../Home/StartYourProject";
import { YouMayAlsoLike } from "./YouMayAlsoLike";

export const Profile = () => {
  const [content, setContent] = useState(<Application />);
  const [activeTab, setActiveTab] = useState("applications");

  function handleApplication() {
    setActiveTab("applications");
    setContent(<Application />);
  }

  function handleAccount() {
    setActiveTab("account");
    setContent(<Account />);
  }

  return (
    <div className="dashboardContainer">
     <div className="breadcrumbContainer">
       <Breadcrumb className="container">
      <Breadcrumb.Item href="/home">Home</Breadcrumb.Item>
      <Breadcrumb.Item href="/profile">
        My Dashboard
      </Breadcrumb.Item>
      
    </Breadcrumb>
     </div>
      <div className="container">
        <div className="dashboardTitle">My Dashboard</div>
        <div className="dashboardDesc">
          Manage your account, view your interests, and stay updated on your
          bidding activity.
        </div>

        <div className="dashboardMenu">
          <div
            onClick={handleApplication}
            className={
              activeTab === "applications" ? "tabItem activeTab" : "tabItem"
            }
          >
            My Applications
          </div>
          <div
            onClick={handleAccount}
            className={
              activeTab === "account" ? "tabItem activeTab" : "tabItem"
            }
          >
            My Account
          </div>
        </div>

        <div className="dashboardContent">{content}</div>
      </div>
      {/* cards  */}
      <YouMayAlsoLike/>

      {/* start your project */}
      <StartYourProject />
    </div>
  );
};
